module.exports = __webpack_public_path__ + "static/media/5DPO9.b8b41a3d.jpg";